import React from 'react';
import { Label } from '../../components/ui/label';
import { Input } from '../../components/ui/input';
import { Checkbox } from '../../components/ui/checkbox';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../components/ui/select';
import { PAYMENT_TYPE_OPTIONS, BILLING_STATUS_OPTIONS, MONTH_NAMES } from '../../constants';
import { formatPaymentName } from '../../utils/helpers';

/**
 * Sección de hitos de facturación en el formulario
 */
const PaymentSection = ({
  formData,
  onFormDataChange,
  payments,
  onTogglePaymentPaid,
  onUpdatePaymentMonth,
  onUpdatePaymentBillingStatus,
  formatPrice,
}) => {
  const getPaymentTypeLabel = (type) => {
    const option = PAYMENT_TYPE_OPTIONS.find(o => o.value === type);
    return option ? option.label : type;
  };

  return (
    <div className="border rounded-lg p-4 bg-gray-50">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Hitos de Facturación</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div className="space-y-2">
          <Label>Importe Total (€)</Label>
          <Input
            type="text"
            placeholder="0,00"
            value={formData.payment_total}
            onChange={(e) => onFormDataChange({ payment_total: e.target.value })}
            data-testid="payment-total-input"
          />
        </div>
        
        <div className="space-y-2">
          <Label>Tipo de Hito</Label>
          <Select
            value={formData.payment_type}
            onValueChange={(value) => onFormDataChange({ payment_type: value })}
            data-testid="payment-type-select"
          >
            <SelectTrigger>
              <SelectValue placeholder="Selecciona tipo" />
            </SelectTrigger>
            <SelectContent>
              {PAYMENT_TYPE_OPTIONS.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      {/* Calendario de Hitos */}
      {payments.length > 0 && (
        <div className="space-y-3">
          <Label>Calendario de Hitos</Label>
          <div className="space-y-2">
            {payments.map((payment, index) => (
              <div
                key={index}
                className="flex items-center gap-4 p-3 bg-white rounded border"
                data-testid={`payment-row-${index}`}
              >
                <Checkbox
                  checked={payment.paid}
                  onCheckedChange={() => onTogglePaymentPaid(index)}
                  data-testid={`payment-checkbox-${index}`}
                />
                
                <span className="font-medium">{formatPaymentName(payment.payment_number, payments.length)}</span>
                
                <span className="text-xs text-gray-500">Mes:</span>
                <Select
                  value={payment.payment_month || ''}
                  onValueChange={(value) => onUpdatePaymentMonth(index, value)}
                  data-testid={`payment-month-${index}`}
                >
                  <SelectTrigger className="w-32 h-8">
                    <SelectValue placeholder="Mes" />
                  </SelectTrigger>
                  <SelectContent>
                    {MONTH_NAMES.map((month) => (
                      <SelectItem key={month} value={month}>
                        {month}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>

                <span className="text-xs text-gray-500">Facturación:</span>
                <Select
                  value={payment.billing_status || 'Pte facturar'}
                  onValueChange={(value) => onUpdatePaymentBillingStatus(index, value)}
                  data-testid={`payment-billing-status-${index}`}
                >
                  <SelectTrigger className="w-32 h-8">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    {BILLING_STATUS_OPTIONS.map((option) => (
                      <SelectItem key={option.value} value={option.value}>
                        {option.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>

                <span className={`font-semibold ml-auto ${payment.paid ? 'text-green-600' : 'text-gray-700'}`}>
                  €{formatPrice(payment.amount)}
                </span>
              </div>
            ))}
          </div>
          
          <div className="text-sm text-gray-500 mt-2">
            Tipo: {getPaymentTypeLabel(formData.payment_type)}
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentSection;
